import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, TextField } from '@mui/material'

import BaseDialog from '../BaseDialog'
import { useDataApi } from '../../context/DataApiContext'
import { useNotificationsProvider } from '../../context/NotificationsContext'
import { getPVAdmissionErrorMessages } from '../../utils/pvAdmissionTemplateErrors'

const KEY = 'pv-admission-management'

export default function RenameTemplateDialog({
  template,
  onClose = () => {},
  onRenamed = () => {},
}) {
  const { t } = useTranslation()
  const { dataProvider } = useDataApi()
  const { showNotification } = useNotificationsProvider()

  const [name, setName] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setName(template ? template.name : '')
  }, [template])

  const onConfirm = () => {
    setLoading(true)
    dataProvider.pvAdmissionTemplates
      .rename(template.id, name.trim())
      .then(() => {
        showNotification('success', t(`${KEY}.rename-success`))
        onRenamed()
      })
      .catch((err) =>
        getPVAdmissionErrorMessages(err, t).forEach((message) =>
          showNotification('error', message)
        )
      )
      .finally(() => setLoading(false))
  }

  return (
    <BaseDialog
      open={!!template}
      onClose={onClose}
      onConfirm={onConfirm}
      title={t(`${KEY}.rename`)}
      loading={loading}
      confirmDisabled={name.trim().length === 0}
    >
      <Grid container direction="column" spacing={3} sx={{ pt: 2 }}>
        <Grid item>
          <TextField
            variant="standard"
            required
            id="pv-admission-template-rename"
            label={t(`${KEY}.create-dialog.name`)}
            fullWidth
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </Grid>
      </Grid>
    </BaseDialog>
  )
}
